import { Link } from "react-router-dom";

export default function HeroSection() {
  return (
    <section className="w-full bg-dark-bg pt-24 md:pt-32 pb-16 md:pb-24">
      <div className="w-full px-4 md:px-8">
        <div className="flex flex-col items-center text-center">
          {/* Title */}
          <h2 className="text-white font-bold text-xl md:text-2xl mb-4">
            끊김없는 고화질 스포츠중계
          </h2>
          <p className="text-dark-text-muted text-base md:text-lg mb-8">
            스포츠중계 할매티비가 책임집니다.
          </p>

          {/* Hero Image - Logo Banner */}
          <div className="mb-10">
            <Link to="/live">
              <img
                src="https://storage.readdy-site.link/project_files/ea9bd2f5-a5fa-48e1-adb8-14e6c6a8dddd/39001f87-94f8-4788-9d8a-585e79d11d93_logo.png?v=4a092eb770424da0016aa1f907a04388"
                alt="할매티비 스포츠중계"
                width="400"
                height="400"
                className="mx-auto max-w-[280px] md:max-w-[360px] w-full h-auto"
              />
            </Link>
          </div>

          {/* Domain URL */}
          <div className="mb-8 flex flex-col items-center gap-2">
            <a
              href="https://halmae28.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group flex items-center gap-3 bg-brand-orange/10 border border-brand-orange/30 rounded-full px-6 py-3 hover:bg-brand-orange/20 hover:border-brand-orange/50 transition-all"
            >
              <i className="ri-links-line text-brand-orange text-xl"></i>
              <span className="text-brand-orange text-lg md:text-xl font-semibold tracking-wide">
                https://halmae28.com
              </span>
              <i className="ri-arrow-right-up-line text-brand-orange text-lg group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-transform"></i>
            </a>
            <span className="text-dark-text-muted text-sm flex items-center gap-1">
              <i className="ri-external-link-line"></i>
              클릭해서 방문하기
            </span>
          </div>

          {/* CTA Buttons */}
          <div className="flex flex-col items-center gap-4 w-full max-w-md">
            <a
              href="https://halmae28.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-full text-center transition-all whitespace-nowrap flex items-center justify-center gap-3"
            >
              <i className="ri-chat-smile-2-line text-xl"></i>
              <span>할매티비 커뮤니티 바로가기</span>
              <i className="ri-arrow-right-up-line text-lg opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"></i>
            </a>
            <a
              href="https://halmae28.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-full text-center transition-all whitespace-nowrap flex items-center justify-center gap-3"
            >
              <i className="ri-tv-line text-xl"></i>
              <span>스포츠중계 바로가기</span>
              <i className="ri-arrow-right-up-line text-lg opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"></i>
            </a>
            <a
              href="https://halmae28.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-full text-center transition-all whitespace-nowrap flex items-center justify-center gap-3"
            >
              <i className="ri-speed-up-line text-xl"></i>
              <span>스피드 스포츠중계</span>
              <i className="ri-arrow-right-up-line text-lg opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"></i>
            </a>
            <a
              href="https://halmae28.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-full text-center transition-all whitespace-nowrap flex items-center justify-center gap-3"
            >
              <i className="ri-movie-line text-xl"></i>
              <span>4K 스포츠중계</span>
              <i className="ri-arrow-right-up-line text-lg opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"></i>
            </a>
            <a
              href="https://halmae28.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group w-full bg-brand-orange hover:bg-brand-orange-hover text-white font-bold text-base md:text-lg py-4 px-8 rounded-full text-center transition-all whitespace-nowrap flex items-center justify-center gap-3"
            >
              <i className="ri-live-line text-xl"></i>
              <span>실시간방송</span>
              <i className="ri-arrow-right-up-line text-lg opacity-0 -translate-x-2 group-hover:opacity-100 group-hover:translate-x-0 transition-all"></i>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}